import React from 'react';
import { LockIcon, SparklesIcon, ShieldCheckIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-wrap items-center justify-center gap-4 md:gap-4 gap-y-3 text-sm text-stone-600" data-id="element-558">
      <div className="flex items-center gap-2" data-id="element-559">
        <LockIcon className="w-4 h-4 text-emerald-700" data-id="element-560" />
        <span data-id="element-561">Secure checkout</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-562">
        <SparklesIcon className="w-4 h-4 text-emerald-700" data-id="element-563" />
        <span data-id="element-564">Instant digital access</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-565">
        <ShieldCheckIcon className="w-4 h-4 text-emerald-700" data-id="element-566" />
        <span data-id="element-567">30-day money-back guarantee</span>
      </div>
    </div>;
}